import React, { useState, useRef } from 'react';
import ExportApi from "../../api/ExportApi";
import { toast } from 'react-toastify';

function ProductSeoTags() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  // Create a ref for the file input
  const fileInputRef = useRef();

  // Handle file selection and check if it's a valid CSV
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const fileType = selectedFile?.type;

    // Check if the file type is CSV
    if (fileType !== 'text/csv') {
      toast.error('Please upload a valid CSV file.');
      setFile(null); // Reset the file state if the file type is not CSV
      fileInputRef.current.value = ''; // Reset the file input visually
    } else {
      setFile(selectedFile); // Set file if it's valid
    }
  };

  // Function to download the CSV data
  const handleDownloadCsv = async () => {
    try {
      const response = await ExportApi.downloadproductcsv();
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'products.csv';
      link.click();
    } catch (error) {
      console.error('Error downloading CSV:', error);
    }
  };

  // Function to upload the CSV file
  const handleUploadCsv = async () => {
    if (!file) {
      alert('Please select a CSV file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('csvFile', file);
    setUploading(true);

    try {
      const resp = await ExportApi.updateproductseo(formData);
      // console.log(resp,"resp>>>data");
      if (resp?.data === "CSV file uploaded successfully, will be processed shortly.") {
        toast.success('CSV uploaded successfully!');
        setFile(null); // Clear the file state
        fileInputRef.current.value = ''; // Clear the file input visually
      }
    } catch (error) {
      toast.error('Error uploading CSV.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <h5 className='mt-3'>All Products</h5>

      {/* Download CSV Section */}
      <div className='mt-3'>
        <button
          onClick={handleDownloadCsv}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#189754',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#16a04f'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#189754'}
        >
          Download CSV
        </button>
        <p>First download the latest csv products data</p>
      </div>

      <hr style={{ margin: '20px 0', borderTop: '1px solid #ddd' }} />

      {/* Upload CSV Section */}
      <div>
        <input
          ref={fileInputRef} // Assign the ref to the file input
          type="file"
          accept=".csv" // Restrict file selection to CSV only
          onChange={handleFileChange}
          style={{
            padding: '10px',
            fontSize: '16px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            marginBottom: '10px',
          }}
        />
        <div>
          <button
            onClick={handleUploadCsv}
            disabled={uploading}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: uploading ? '#189754' : '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: uploading ? 'not-allowed' : 'pointer',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              position: 'relative',
            }}
          >
            {uploading ? (
              <span>Uploading...</span>
            ) : (
              'Upload CSV'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductSeoTags;
